<template>
  <div>
    <v-layout wrap>
      <v-flex v-if="isEdit" xs12>
        <BeaconManage
          v-if="isEdit"
          v-model="beaconItemEdit"
          type="edit"
          @onSave="handleSaveBeacon($event, 'edit')"
          @onCancel="isEdit = false"
        />
      </v-flex>
      <template v-else>
        <v-flex xs12 sm8 class="pa-2">
          <div class="primary--text ma-0">{{ item.beacon_id }}_{{ item.name }}</div>
          <div class="mt-3" style="display: flex">
            <div class="primary--text" style="width: 100px">Beacon ID</div>
            <div>{{ item.beacon_id }}</div>
          </div>
          <div style="display: flex">
            <div class="primary--text" style="width: 100px">{{ $t('location') }}</div>
            <div>{{ item.location }}</div>
          </div>
          <div style="display: flex">
            <div class="primary--text" style="width: 100px">{{ $t('Tag') }}</div>
            <div>{{ item.tag !== '' ? item.tag : '-' }}</div>
          </div>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-right">
          <v-btn
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="handleEditBeacon(item)"
          >
            <i class="fas fa-pencil-alt"></i>
          </v-btn>
          <v-btn
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="handleDeleteBeaconItem(item)"
          >
            <i class="fa fa-trash middle"></i>
          </v-btn>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import BeaconManage from './BeaconManage'

export default {
  components: {
    BeaconManage
  },
  props: ['item'],
  data() {
    return {
      isEdit: false,
      beaconItem: {},
      beaconItemEdit: {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    if (this.item) {
      this.beaconItem = this.item
    }
  },
  methods: {
    handleSaveBeacon(value, type) {
      this.postCreateBeacon(value, type)
    },

    async postCreateBeacon(beaconItem, type) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await beaconApi.postCreateBeacon({
          data: {
            pageid: vm.selectedBot.pageid,
            body: {
              beacon_id: beaconItem.beacon_id,
              name: beaconItem.name, // optional
              location: beaconItem.location, // optional
              tag: beaconItem.tags // optional
            }
          }
        })
        vm.$store.dispatch('loading')

        handleResponse(response)
        if (response && response.data && response.data.success) {
          if (type === 'add') {
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `Beacon ${beaconItem.name} ถูกเพิ่มแล้ว`,
              type: 'success'
            })
          } else {
            vm.isEdit = false
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `Beacon ${beaconItem.name} ถูกแก้ไขแล้ว`,
              type: 'success'
            })
          }

          vm.$emit('onFetchData')
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
      }
    },

    handleEditBeacon(item) {
      const beacon = JSON.stringify(item)
      this.beaconItemEdit = JSON.parse(beacon)
      this.isEdit = true
    },
    async handleDeleteBeaconItem(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: 'Beacon ' + item.name
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteBeacon(item)
          vm.$store.dispatch('loading')

          if (response && response.data && response.data.success) {
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `Beacon ${item.name} ${vm.$t('has_been_deleted')}`,
              type: 'success'
            })
            vm.$emit('onFetchData')
          }
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async deleteBeacon(item) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await beaconApi.deleteBeaconItem({
          data: {
            pageid: vm.selectedBot.pageid,
            config_id: item.id
          }
        })
        vm.$store.dispatch('loading')
        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/BeaconItem.vue